import { render, staticRenderFns } from "./ViewDataButton.vue?vue&type=template&id=37158570&scoped=true&"
import script from "./ViewDataButton.vue?vue&type=script&lang=js&"
export * from "./ViewDataButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewDataButton.vue?vue&type=style&index=0&id=37158570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37158570",
  null
  
)

export default component.exports